import React from "react";
import Pim from "../Components/urunlerimiz/Pim";
import PageHeader from "../Components/common/PageHeader";
import Spacer4 from "../Components/common/Spacer4";
import { useTranslation } from "react-i18next";
import TopBar from "../Components/common/TopBar";
import useSEO from "../seo/useSEO";

function PimPage() {
  const { t } = useTranslation();

  useSEO({
    title: "Özel Üretim Pim İmalatı | Aypin Otomat",
    description:
      "Aypin Otomat özel üretim pim çözümleri ve CNC kayar otomat ile hassas talaşlı imalat hizmetleri hakkında bilgi alın.",
    path: "/pim",

    breadcrumbs: [
      {
        name: "Ana Sayfa",
        path: "/",
      },
      {
        name: "Ürünlerimiz",
        path: "/urunlerimiz",
      },
      {
        name: "Özel Üretim Pimler",
        path: "/pim",
      },
    ],
  });

  return (
    <>
      <TopBar />
      <Spacer4 />

      <PageHeader
        title={t("Özel Üretim Pimler")}
      />

      <Pim />
    </>
  );
}

export default PimPage;